// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'

class CallToActionHeadingTextLink extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props

		if ( ! data ) {
			return null
		}

		return (
			<div className="section-call-to-action-heading-text-link">
				<div className="-heading">

				</div>

				<div className="-inner">

				</div>
			</div>
		)
	}
}

export default CallToActionHeadingTextLink
